import { useTranslation } from 'react-i18next'
import {
  LogoWrapper,
  ProducerLogo,
  ScoreLabel,
  ScoreWrapper,
  WineInfoWrapper,
  WineName,
  WineProducer,
  WineProducerText,
  WineSpecification,
  Wrapper,
} from './_styles'
import LogoPlaceholder from '../../TechListPreview/Icons/LogoPlaceholder'
import FlagIcon from 'components/Common/FlagIcon'
import { delimiter } from 'utils/consts/string'
import Score from 'components/Common/Score'
import {
  formatBottleSize,
  getWineColorString,
  getWineSweetnessString,
  getWineTitleBrand,
  getWineTypeString,
} from 'utils/wine'
import LineClamp from '../LineClamp'

const getProductSpecification = product => {
  const wine = product?.wine

  return [
    getWineTypeString(wine),
    getWineColorString(wine),
    getWineSweetnessString(wine),
    formatBottleSize(product?.bottleSize?.volumeML),
    !product?.packageType?.isDefault
      ? product?.packageType?.localizedName
      : null,
  ]
    .filter(Boolean)
    .join(delimiter)
}

const Header = ({ product }) => {
  const { t } = useTranslation()
  const wine = product?.wine
  const country = wine?.country
  const tradeName = wine?.tradeName?.tradeName
  const h1Text = [country?.localizedName, tradeName].join(', ')
  const wineName = getWineTitleBrand(wine)
  const wineSpecification = getProductSpecification(product)
  const rating = wine?.rating
  const logo = wine?.tradeName?.logo?.imageUrl

  return (
    <Wrapper>
      <LogoWrapper>
        {logo ? <ProducerLogo src={logo} /> : <LogoPlaceholder size='212px' />}
      </LogoWrapper>
      <WineInfoWrapper>
        <WineProducer>
          <FlagIcon codeISO={country?.codeISO} size={32} />
          <WineProducerText>{h1Text}</WineProducerText>
        </WineProducer>
        <WineName>
          <LineClamp lines={2}>{wineName}</LineClamp>
        </WineName>
        <WineSpecification>{wineSpecification}</WineSpecification>

        {wine?.techSheet?.isWwlScoreUsed !== false && rating > 0 && (
          <ScoreWrapper>
            <Score value={rating} />
            <ScoreLabel>{t('wine.techlist.wwlScore')}</ScoreLabel>
          </ScoreWrapper>
        )}
      </WineInfoWrapper>
    </Wrapper>
  )
}

export default Header
